import { useQuery } from "react-query";
import { reactQueryGet } from "@/react/helpers/backendRequestHelpers";
import { internalApi } from "@/react/helpers/urlHelpers";
import type { ExtraStorage } from "@/react/components/SettingsApp/MediaManager/StorageDistribution/types";

const REQUEST_KEY = ["settings", "storage", "metrics"];

interface StorageMetricsResponse {
  audio_bytes: number;
  extra_storage: ExtraStorage | null;
  image_bytes: number;
  other_bytes: number;
  recording_bytes: number;
  total_bytes_in_plan: number;
  total_bytes_used: number;
  video_bytes: number;
  video_transcoding_bytes: number;
}

export const useStorageMetricsApi = () => {
  const fetchStorageMetrics = (): Promise<StorageMetricsResponse> =>
    reactQueryGet(internalApi.settings.storage.metrics.show());

  const {
    data,
    isLoading: isLoadingStorageMetrics,
    refetch: refetchStorageMetrics,
  } = useQuery(REQUEST_KEY, fetchStorageMetrics);

  return {
    totalBytesUsed: data?.total_bytes_used ?? 0,
    totalBytesInPlan: data?.total_bytes_in_plan ?? 0,
    imageBytes: data?.image_bytes ?? 0,
    videoBytes: data?.video_bytes ?? 0,
    videoTranscodingBytes: data?.video_transcoding_bytes ?? 0,
    audioBytes: data?.audio_bytes ?? 0,
    recordingBytes: data?.recording_bytes ?? 0,
    otherBytes: data?.other_bytes ?? 0,
    extraStorage: data?.extra_storage ?? null,
    isLoadingStorageMetrics,
    refetchStorageMetrics,
  };
};
